import { View, Text, Image } from "@react-pdf/renderer";

import { Colors } from "../../../configs";
import { image1, image2 } from "../customer/imagesStrings";
import { getStoreHeader } from "../../../util/store-header";

const ReportHeader = () => {
  const storeHeader = getStoreHeader();
  return (
  <View fixed>
    <Image
      src={image1}
      style={{ width: "100%", height: "auto", marginBottom: 10 }}
    />

    <View
      style={{
        marginBottom: 15,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        position: "absolute",
        left: "4rem",
        top: "3.8rem",
        gap: "15.1rem",
        marginTop: 18,
      }}
    >
      <View>
        <Text
          style={{
            fontSize: 11,
            fontWeight: "bold",
            color: Colors.REPORT_GREEN,
            marginBottom: 0.5,
          }}
        >
          {storeHeader.name}
        </Text>
        <Text style={{ fontSize: 9, marginBottom: 1 }}>
          {storeHeader.subtitle}
        </Text>
        <Text style={{ fontSize: 9, marginBottom: 1 }}>
          {storeHeader.address}
        </Text>
        <Text style={{ fontSize: 9, marginBottom: 1 }}>
          TP: {storeHeader.phone} | {storeHeader.email}
        </Text>
        <Text style={{ fontSize: 9 }}>{storeHeader.website}</Text>
      </View>

      <Image src={image2} style={{ width: "100px", height: "50px" }} />
    </View>
    <View
      style={{
        borderBottomWidth: 1.5,
        borderBottomColor: Colors.REPORT_DARK_GREEN,
        marginVertical: 10,
        marginTop: 52,
        marginLeft: 48,
        marginRight: 30,
      }}
    />
  </View>
  );
};

export default ReportHeader;
